import { SelectInputField } from './select-input-field';
import { ServicePlanVariantType } from 'api-new/generated';
import { SelectOptions } from 'ts-types';

export type PriceTypeOption = SelectOptions<ServicePlanVariantType, string>;

type PriceTypeFieldProps = {
  name?: string;
  label?: string;
  required?: boolean;
  isSmallSize?: boolean;
  showError?: boolean;
  options: PriceTypeOption[];
  disabled?: boolean;
};

export const PriceTypeField = ({
  name = 'variantType',
  label,
  required,
  isSmallSize = true,
  showError,
  options,
  disabled
}: PriceTypeFieldProps) => {
  return (
    <SelectInputField
      name={name}
      label={label}
      values={options}
      required={required}
      isSmallSize={isSmallSize}
      showError={showError}
      disabled={disabled}
    />
  );
};
